import { Box, Tab, Tabs } from "@mui/material";
import { StratifyDocument } from "@stratify/shared";
import React, { useState } from "react";
import { AgentChatTab } from "../../../agentChat/components/AgentChatTab";
import { InsightsTab } from "../../../insights/components/InsightsTab";
import { DetailsTab } from "./DetailsTab";
import { LogsTab } from "./LogsTab";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  flex?: number;
  display?: string;
  padContainer?: boolean;
}

function TabPanel(props: TabPanelProps) {
  const {
    children,
    value,
    index,
    flex,
    display,
    padContainer = true,
    ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`document-sidebar-tabpanel-${index}`}
      aria-labelledby={`document-sidebar-tab-${index}`}
      style={{
        display: value === index ? display : "none",
        flex: flex,
        flexDirection: "column",
        maxHeight: "100%",
      }}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            display: "flex",
            height: "100%",
            p: padContainer ? 2 : 0,
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

interface DocumentSidebarProps {
  document: StratifyDocument;
}

export const DocumentSidebar: React.FC<DocumentSidebarProps> = ({
  document,
}) => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Box
      sx={{
        flex: 1,
        borderTop: 1,
        borderColor: "divider",
        display: "flex",
        flexDirection: "column",
        maxHeight: "100%",
      }}
      id="document-sidebar"
    >
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        aria-label="document sidebar tabs"
        variant="fullWidth"
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab label="Chat" data-testid="chat-tab" />
        <Tab label="Details" data-testid="details-tab" />
        <Tab label="Insights" data-testid="insights-tab" />
        <Tab label="Logs" data-testid="logs-tab" />
      </Tabs>

      <Box
        data-testid="tabs-content"
        sx={{
          overflowY: "auto",
          flex: 1,
          maxHeight: "100%",
          minHeight: 0,
          display: "flex",
        }}
      >
        <TabPanel
          value={currentTab}
          index={0}
          flex={1}
          display="flex"
          padContainer={false}
        >
          <AgentChatTab document={document} />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <DetailsTab document={document} />
        </TabPanel>

        <TabPanel value={currentTab} index={2}>
          <InsightsTab document={document} />
        </TabPanel>

        <TabPanel value={currentTab} index={3}>
          <LogsTab document={document} />
        </TabPanel>
      </Box>
    </Box>
  );
};
